import { Base } from './_base';

export class MenuBackend extends Base {
  constructor(item) {
    super(item);  }
}
